import ScrollAnimationWrapper from '../helpers/ScrollAnimationWrapper'
import gradeSvg from '../../assets/elements/grade.svg'
import lobbyImg from '../../assets/ART/hall.webp'
import localizationImg from '../../assets/ART/mapa-ART.png'
import { DescriptionBlock } from '../DescriptionBlock'
import { Container, LocationContent } from './styles'

export function SectionLocalizacaoPrivilegiada() {
  return (
    <Container>
      <img src={gradeSvg} alt="grade vertical" className="grade-vertical" />
      <img src={lobbyImg} alt="lobby" className="lobby" />
      <LocationContent>
        <div className="description-content">
          <ScrollAnimationWrapper animateIn="animate__fadeIn">
            <div className="fancy-text-container">
              <div className="fancy-text-bg" />
              <h2 className="fancy-text">Localização Privilegiada</h2>
            </div>
          </ScrollAnimationWrapper>

          <p>
            O Lux Design ART está localizado no coração do bairro de Nazaré, em
            plena José Malcher, uma via central com um entorno estratégico
            repleto de facilidades.
          </p>
        </div>
        <div className="footer-content">
          <ScrollAnimationWrapper animateIn="animate__fadeInRight">
            <img
              src={localizationImg}
              alt="josé malcher"
              className="img-fluid mapa"
            />
          </ScrollAnimationWrapper>
          <div className="description">
            <DescriptionBlock
              strong="Entre em grande estilo"
              text="Sinta-se bem desde a entrada"
              bgColor="#E4947A"
            />
          </div>
        </div>
      </LocationContent>
    </Container>
  )
}

